<template>
    <div class="checkout-user-properties">
        <!-- <span v-if="result.title">{{ result.title }}</span>-->
        <div class="checkout-user-properties__grid">
            <div class="checkout-user-properties__block">
                <ul v-if="result.properties">
                    <li v-for="prop in result.properties" :key="prop.ID" v-if="prop.PROPS_GROUP_ID == 1">
                        <div v-if="prop.TYPE === 'STRING'">
                            <def-email v-if="prop.CODE === 'EMAIL'"
                                       :name="getName(prop)"
                                       v-model="prop.VALUE[0]"
                                       :label="prop.NAME"
                                       :invalidText="getErrortext(prop)"
                                       :required="prop.REQUIRED === 'Y'"
                            />
                            <DefPhone v-else-if="prop.CODE === 'PHONE'"
                                       :name="getName(prop)"
                                       :value="prop.VALUE[0]"
                                       :label="prop.NAME"
                                       :invalidText="getErrortext(prop)"
                                       :required="prop.REQUIRED === 'Y'"
                            />
                            <def-input  v-else
                                        :name="getName(prop)"
                                        v-model="prop.VALUE[0]"
                                        :invalidText="getErrortext(prop)"
                                        :label="prop.NAME"
                                        :required="prop.REQUIRED === 'Y'"
                            />
                        </div>
                        <div v-else>
                            ID: {{ prop.ID }}
                            Name: {{ prop.NAME }} <br>
                            Type: {{ prop.TYPE }}
                        </div>
                    </li>
                </ul>

                <div v-if="result.userConfirmData" class="checkout-user-properties__agree">
                    <def-checkbox :required="true"
                                  :invalidText="result.messages.confirmPersonal"
                                  :checked="true"
                    >
                      {{ result.userConfirmData.text }}
                    </def-checkbox>
                    <a v-if="result.userConfirmData.link"
                       class="def-link"
                       :href="result.userConfirmData.link.href"
                    >{{ result.userConfirmData.link.text }}</a>
                </div>

            </div>
            <div v-if="result.userInfo" class="checkout-user-properties__information">
                <h5 v-if="result.userInfo.title" class="def-title-5">{{result.userInfo.title}}</h5>
                <p v-if="result.userInfo.description" class="checkout-user-properties__inform-text">{{result.userInfo.description}}</p>
                <a v-if="result.userInfo.link" class="get-authorization" :href="result.userInfo.link.href">{{result.userInfo.link.text}}</a>
            </div>
        </div>

<!--        <div class="def-button" @click="$emit('changeStep', 2)">{{result.messages.nextStep}}</div>-->
    </div>
</template>

<script>
import DefPhone from "../def/DefPhone/DefPhone";
export default {
    name: "checkout-user-properties",
    props: ['result'],
    components: {
        DefPhone
    },
    methods: {
        getName: function (prop) {
            return 'ORDER_PROP_'+prop.ID;
        },
        getValue: function (prop) {
            return prop.VALUE[0];
        },
        isValidInput(type) {
            return !!this.errors.find(el => el === type)
        },
        getErrortext(prop) {
            let res = "";
            if(prop.messages!=undefined) {
                res = prop.messages.errorText;
            }
            return res;
        },
        // handlerChangePhone(prop) {
        //     this.$modal.show({
        //         template: `
        //             <modal-wrapper>
        //                 <change-phone :result="result" />
        //             </modal-wrapper>
        //         `,
        //         props: ['result']
        //     }, {
        //         result: prop,
        //     },{
        //         width: 368,
        //         height: 'auto',
        //     })
        // }
    },
    mounted() {
        console.log(this.result);
    }
}
</script>

<style lang="scss">
    .checkout-user-properties{
        &__grid{
            display: flex;
            flex-direction: column;
            @include point-md{
                flex-direction: row;
            }
        }
        &__agree{
            display: flex;
            flex-direction: column;
            font-size: rem(14);
            line-height: 100%;
            color: var(--text-colour-primary);
            margin: 18px 0 24px;
            .def-checkbox + *{
                margin-bottom: 5px;
                padding-left: 24px;
                font-size: rem(12);
                @include point-md{
                    font-size: rem(16);
                }
                &:before{
                    width: 16px;
                    height: 16px;
                }
                &:after{
                    width: 8px;
                    height: 8px;
                    top: 4px;
                    left: 4px;
                }
            }
            .def-link {
                color: #757575;
                text-decoration-style: dashed;
                margin-left: 24px;
                font-size: rem(12);
                @include point-md{
                    font-size: rem(16);
                }
                &:hover{
                    color: #757575;
                    text-decoration-style: dashed;
                }
            }
        }
        &__block{
            width: 100%;
            max-width: 400px;
            @include point-md{
                max-width: 356px;
            }
            @include point-lg{
                max-width: 400px;
            }
            input{
                margin-bottom: 8px;
            }
        }
        &__information{
            max-width: 400px;
            @include point-md{
                padding-left: 32px;
            }
            .def-title-5{
                margin-bottom: 8px;
                letter-spacing: unset;
                text-transform: unset;
                font-size: rem(16);
                @include point-md{
                    font-size: rem(18);
                }
            }
        }
        &__inform-text{
            margin-bottom: 16px;
            font-size: rem(16);
            line-height: 110%;
            color: #757575;
            @include point-md{
                margin-bottom: 24px;
            }
            b{
                color: var(--text-colour-primary);
            }
            .def-link{
                color: var(--text-colour-secondary);
                text-decoration-style: dashed;
                &:hover{
                    color: var(--text-colour-secondary);
                    text-decoration-style: dashed;
                }
            }
        }
        &__phone{
            position: relative;
            margin-bottom: 8px;
            .def-input{
                margin-bottom: 0;
            }
        }
        //&__change{
        //    position: absolute;
        //    top: 50%;
        //    right: 16px;
        //    transform: translateY(-50%);
        //    font-weight: 500;
        //    font-size: rem(12);
        //    line-height: 115%;
        //    letter-spacing: 0.1em;
        //    text-transform: uppercase;
        //    color: #191918;
        //    cursor: pointer;
        //    text-decoration: underline;
        //    text-decoration-style: dashed;
        //    text-decoration-color: #191918;
        //    text-underline-position: under;
        //}
        .def-input{
            width: 100%;
        }
        .get-authorization{
            font-weight: 500;
            font-size: rem(14);
            color: var(--text-colour-secondary);
            @include point-md{
                font-size: rem(16);
            }
        }
    }
</style>